export default "__VITE_ASSET__21b2cc3b__"